import React from 'react';
import V4PModelZoo from '../components/V4PModelZoo/V4PModelZoo';

const QMBlueprintPage = () => {
  return <V4PModelZoo publicOnly />;
};

export default QMBlueprintPage;